export default function Footer() {
  return (
    <footer id="footer" style={{ background:'var(--white)', borderTop:'2.5px solid var(--black)' }}>
      {/* Top accent bar */}
      <div style={{ height:'6px', background:'var(--accent)', borderBottom:'2.5px solid var(--black)' }} />
      <div className="container" style={{ padding:'3rem 2.5rem', display:'flex', flexWrap:'wrap', justifyContent:'space-between', alignItems:'flex-end', gap:'2rem' }}>
        <div>
          <div style={{ fontFamily:'var(--font-head)', fontSize:'1.2rem', fontWeight:700, marginBottom:'0.5rem' }}>
            JI 101 — <span style={{ color:'var(--accent)' }}>Justice Innovation 101</span>
          </div>
          <div style={{ fontFamily:'var(--font-body)', fontSize:'0.82rem', color:'var(--muted)', lineHeight:1.8 }}>
            Awaaz Leadership Labs × Amity University Gwalior · 2025
          </div>
          <div style={{ fontFamily:'var(--font-body)', fontSize:'0.72rem', color:'#AAA', fontStyle:'italic', marginTop:'0.4rem' }}>
            Based on survey responses from 54 real participants
          </div>
        </div>

        <div style={{ display:'flex', gap:'1rem', flexWrap:'wrap' }}>
          {[
            { label:'Instagram', href:'https://www.instagram.com/awaaz_leadershiplabs' },
            { label:'LinkedIn', href:'https://www.linkedin.com/company/awaazleadershiplabs/' },
            { label:'awaaz.space', href:'https://awaaz.space' },
          ].map(({ label, href }) => (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="tag tag-ghost"
              style={{ textDecoration:'none', transition:'background 0.15s, color 0.15s' }}
              onMouseEnter={e => { e.currentTarget.style.background='var(--black)'; e.currentTarget.style.color='var(--white)'; e.currentTarget.style.borderColor='var(--black)'; }}
              onMouseLeave={e => { e.currentTarget.style.background='transparent'; e.currentTarget.style.color='var(--muted)'; e.currentTarget.style.borderColor='#AAAAAA'; }}
            >{label}</a>
          ))}
        </div>
      </div>
    </footer>
  );
}
